export default __webpack_public_path__ + "static/media/printer.477c81fa.png";